import React from "react";
import axios from "../../../../containers/api";
import { showCatchError, toEnglishNumbers } from "../../../../helpers/Utils";
import {
  Button,
  Card,
  CardBody,
  ModalBody,
  Modal,
  ModalHeader,
  Row,
  ModalFooter,
  Alert,
  Badge,
} from "reactstrap";
import { Table } from "../../../../components/table/Table";
import {
  Colxx,
  Separator,
} from "../../../../components/common/CustomBootstrap";
import AddProductOwner from "./components/AddProductOwner";
import EditProductOwner from "./components/EditProductOwner";
import Config from "../../../../constants/config";
class ManageProductOwner extends React.Component {
  state = {
    EditModal: false,
    AddModal: false,
    productOwners: [],
    oneProductOwner: {},
    FileUploadModal: false,
    ShowFileUploadModal: false,
    showNewMemberModal: false,
  };

  componentDidMount() {
    //this.checkPermission();
    this.ProductOwners();
  }

  //checkPermission = () => {
  //    this.props.showSpinner();
  //    axios.get('api/ClientApi/HasAccessTo?permissionName=ProductOwner_List')
  //        .then((res) => {
  //            if (res.data) {
  //                this.ProductOwners();
  //            } else {
  //                this.props.history.push('/error404');
  //            }
  //        })
  //        .catch((error) => {
  //            this.props.hideSpinner();
  //            this.props.showAlert(showCatchError(error), "error");
  //            console.log(error.response);
  //        });
  //};

  ProductOwners = () => {
    axios
      .get("/api/v1/product-owners/GetAllProductOwner")
      .then((res) => {
        this.props.hideSpinner();
        this.setState({ productOwners: res.data.data });
        //console.log(res.data)
      })
      .catch((error) => {
        this.props.hideSpinner();
        this.props.showAlert(showCatchError(error), "error");
        console.log(error.response);
      });
  };

  Delete = (id) => {
    this.props.closeSweetAlert();
    this.props.showSpinner();
    let model = {
      Id: id,
    };
    axios
      .post("/api/v1/product-owners/DeleteProductOwner", model)

      .then((res) => {
        this.props.hideSpinner();
        if (res.data.data.code !== 1 && res.data.data.code !== "1") {
          this.props.showAlert(res.data.message, "error");
        } else {
          this.props.showAlert(res.data.message, "success");
          this.ProductOwners();
        }
      })
      .catch((error) => {
        this.props.hideSpinner();
        this.props.showAlert(showCatchError(error), "error");
        console.log(error.response);
      });
  };

  closeModal = (modalName) => {
    this.setState({ [modalName]: false });
    this.ProductOwners();
  };
  createMembershipForProductOwner = (Id) => {
    this.props.closeSweetAlert();
    this.props.showSpinner();
    axios
      .post("api/v1/Product-Owners/CreateProductOwnerUser?ProductOwnerId=" + Id)
      .then((res) => {
        if (res.data.data !== null) {
          this.props.hideSpinner();
          this.props.showAlert("حساب کاربری با موفقیت ساخته شد", "success");
          this.setState({
            newMemberUsername: res.data.data.userName,
            newMemberPassword: res.data.data.password,
            showNewMemberModal: true,
          });
          this.ProductOwners();
        } else {
          this.props.hideSpinner();
          this.props.showAlert(res.data.errors, "error");
        }
      })
      .catch((error) => {
        this.props.hideSpinner();
        console.log(error.response);
        this.props.showAlert(showCatchError(error), "error");
      });
  };
  AcceptProductOwner = (id) => {
    this.props.closeSweetAlert();
    this.props.showSpinner();
    axios
      .post("api/v1/ProductOwner/AcceptProductOwner?ProductOwnerId=" + id)
      .then((res) => {
        if (res.data.statusCode === 200) {
          this.props.showAlert(res.data.data, "success");
          this.ProductOwners();
        } else {
          this.props.showAlert(res.data.data, "error");
        }
      })
      .catch((error) => {
        this.props.hideSpinner();
        this.props.showAlert(showCatchError(error), "error");
        console.log(error.response);
      });
  };
  render() {
    return (
      <>
        <Row>
          <Colxx xxs="12">
            <h3> صاحبان کالا</h3>
            <Separator className="mb-5" />
          </Colxx>
        </Row>

        <Row className="mb-3">
          <Colxx xxs="12">
            <Card>
              <CardBody className="d-flex flex-column justify-content-center align-items-center">
                <div className="d-flex justify-content-center w-100">
                  <Button
                    outline
                    color="primary"
                    className="mx-3"
                    onClick={() => this.setState({ AddModal: true })}
                  >
                    افزودن صاحب کالا
                  </Button>
                </div>

                <Table
                  tableHeaders={[
                    "نام",
                    "نوع",
                    "کد ملی",
                    "موبایل",
                    "ویرایش",
                    "حذف",
                    "وضعیت",
                    "ساختن",
                    "تایید",
                  ]}
                  tableRow={this.state.productOwners}
                  tableData={[
                    (x) => {
                      return x.firstname + " " + x.lastname;
                    },
                    (x) => {
                      return x.type === false ? "حقیقی" : "حقوقی";
                    },
                    (x) => {
                      return x.meliCode;
                    },
                    (x) => {
                      return x.mobile;
                    },

                    (x) => {
                      return (
                        <Button
                          outline
                          color="info"
                          size="sm"
                          onClick={() =>
                            this.setState({
                              oneProductOwner: x,
                              EditModal: true,
                            })
                          }
                        >
                          ویرایش
                        </Button>
                      );
                    },
                    (x) => {
                      return (
                        <Button
                          outline
                          color="danger"
                          size="sm"
                          onClick={() =>
                            this.props.showSweetAlert(
                              "آیا از حذف اطلاعات اطمینان دارید؟",
                              "",
                              "danger",
                              () => this.Delete(x.id),
                            )
                          }
                        >
                          حذف
                        </Button>
                      );
                    },
                    (x) => {
                      return x.isAccept === false ? (
                        <Badge color="outline-danger" pill>
                          در انتظار تایید
                        </Badge>
                      ) : (
                        <Badge color="outline-success" pill>
                          فعال
                        </Badge>
                      );
                    },
                    (x) => {
                      if (x.isAccept === true) {
                        return (
                          <Button
                            outline
                            color="success"
                            size="sm"
                            onClick={() =>
                              this.props.showSweetAlert(
                                "آیا حساب کاربری برای این صاحب کالا ساخته شود؟",
                                "",
                                "success",
                                () =>
                                  this.createMembershipForProductOwner(x.id),
                              )
                            }
                          >
                            ساختن
                          </Button>
                        );
                      }
                    },
                    (x) => {
                      return (
                        <Button
                          outline
                          color="primary"
                          size="sm"
                          onClick={() =>
                            this.setState({ ShowFileUploadModal: true }, () =>
                              this.setState({ oneProductOwner: x }),
                            )
                          }
                        >
                          تایید
                        </Button>
                      );
                    },
                  ]}
                />
              </CardBody>
            </Card>
          </Colxx>
        </Row>

        <Modal
          isOpen={this.state.AddModal}
          size="xlg"
          toggle={() => this.closeModal("AddModal")}
        >
          <ModalHeader toggle={() => this.closeModal("AddModal")}>
            افزودن صاحب کالا
          </ModalHeader>
          <ModalBody>
            <AddProductOwner
              showSpinner={this.props.showSpinner}
              hideSpinner={this.props.hideSpinner}
              showAlert={this.props.showAlert}
              showSweetAlert={this.props.showSweetAlert}
              closeSweetAlert={this.props.closeSweetAlert}
            />
          </ModalBody>
        </Modal>

        <Modal
          isOpen={this.state.EditModal}
          size="xlg"
          toggle={() => this.closeModal("EditModal")}
        >
          <ModalHeader toggle={() => this.closeModal("EditModal")}>
            ویرایش صاحب کالا
          </ModalHeader>
          <ModalBody>
            <EditProductOwner
              productOwner={this.state.oneProductOwner}
              showSpinner={this.props.showSpinner}
              hideSpinner={this.props.hideSpinner}
              showAlert={this.props.showAlert}
              showSweetAlert={this.props.showSweetAlert}
              closeSweetAlert={this.props.closeSweetAlert}
            />
          </ModalBody>
        </Modal>

        <Modal
          isOpen={this.state.ShowFileUploadModal}
          toggle={() =>
            this.setState({ ShowFileUploadModal: false, oneProductOwner: {} })
          }
        >
          <ModalHeader
            toggle={() =>
              this.setState({ ShowFileUploadModal: false, oneProductOwner: {} })
            }
          >
            نمایش و تایید مدرک
          </ModalHeader>
          <ModalBody>
            <div className="d-flex mt-2 justify-content-center">
              <h3>مدرک:</h3>
              <p className="pl-4">
                {" "}
                <a
                  target="_blank"
                  href={
                    Config.url +
                    "ProductOwnerUploadFile/" +
                    toEnglishNumbers(this.state.oneProductOwner.fileName)
                  }
                >
                  <img
                    alt=""
                    width="50px"
                    height="50px"
                    src={
                      Config.url +
                      "ProductOwnerUploadFile/" +
                      toEnglishNumbers(this.state.oneProductOwner.fileName)
                    }
                  />
                </a>
              </p>
            </div>
            <div className="d-flex mt-2 justify-content-center">
              <Button
                outline
                color="success"
                size="sm"
                onClick={() =>
                  this.props.showSweetAlert(
                    "آیا از تایید این شركت حمل و نقل اطمینان دارید؟",
                    "",
                    "success",
                    () =>
                      this.AcceptProductOwner(this.state.oneProductOwner.id),
                  )
                }
              >
                تایید
              </Button>
            </div>
          </ModalBody>
        </Modal>
        <Modal
          isOpen={this.state.showNewMemberModal}
          toggle={() =>
            this.setState({
              showNewMemberModal: false,
              newMemberUsername: null,
              newMemberPassword: null,
            })
          }
        >
          <ModalHeader
            toggle={() =>
              this.setState({
                showNewMemberModal: false,
                newMemberUsername: null,
                newMemberPassword: null,
              })
            }
          >
            اطلاعات کاربری
          </ModalHeader>
          <ModalBody>
            <Alert color="danger">
              توجه! لطفا اطلاعات کاربری زیر را در اختیار مسئول مربوطه قرار دهید.
              بعد از بستن این پنجره شما قادر به دیدن رمز عبور نخواهید بود.
            </Alert>

            <div>
              <h3>نام کاربری:</h3>
              <p className="pl-4">{this.state.newMemberUsername}</p>

              <h3>رمز عبور:</h3>
              <p className="pl-4">{this.state.newMemberPassword}</p>
            </div>
          </ModalBody>
        </Modal>
      </>
    );
  }
}

export default ManageProductOwner;
